import { MODAL_STRINGS } from './main-modal.strings';

export const modalContent = {
  title: MODAL_STRINGS.END_GAME,
  text: MODAL_STRINGS.END_TEXT,
  image: 'endGame',
  link: 'https://witgritfit.com/player-toolkit/',
};
